import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Button, FlagSelect, Translation } from '../../common';

const Header = ({
  styles,
  isAuthenticated,
  onLanguageSelect,
  onLogout,
  languages,
  language,
}) => (
  <div className={styles['header__wrapper']}>
    <Grid
      container
      justify="flex-end"
      alignItems="center"
      className={styles['header__content']}
    >
      {(languages && languages.length && (
        <Grid item xs="auto">
          <FlagSelect
            onChange={onLanguageSelect}
            countries={languages && languages.map(({ code }) => code)}
            customLabels={
              languages &&
              languages.reduce(
                (acc, lang) => ({ ...acc, [lang.code]: lang.label }),
                {}
              )
            }
            value={language}
            placeholder="Select Language"
            className={styles['header__flag-select']}
            id="page.component.main-layout.flag-select"
          />
        </Grid>
      )) ||
        null}
      {isAuthenticated && (
        <Grid item xs="auto">
          <Button
            id="page.component.main-layout.logout-button"
            className={styles['header__logout']}
            variant="text"
            onClick={onLogout}
          >
            <Translation>LOGOUT_BUTTON</Translation>
          </Button>
        </Grid>
      )}
    </Grid>
  </div>
);

Header.propTypes = {
  styles: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  onLanguageSelect: PropTypes.func,
  onLogout: PropTypes.func,
};

export default Header;
